import React from 'react';
import Button from '../../components/Button';
import "./style.scss";

function Buttons({content}) {
  return (
    <div className="Buttons">
      {content.buttons?.map((button, index) => (
        <Button
          size="large"
          type="link"
          style={{
            backgroundColor: button.color,
          }}
          key={index}
          to={button.link.url}
          target={button.link.target}
          className="Buttons__button"
          dangerouslySetInnerHTML={{__html: button.link.title}}
        />
      ))}
    </div>
  );
}

export default Buttons;
